import type { Items } from "store/modules/Orders/types.store";
import type { CatalogProductsProps } from "store/modules/Catalog/types.store";

export function isGasDoPovoCatalogProduct(
  product: Pick<CatalogProductsProps, "attributes"> | null | undefined,
): boolean {
  return product?.attributes?.gasDoPovo === true;
}

export function isGasDoPovoOrderItem(item: Items | undefined): boolean {
  return !!item?.attributes?.gasDoPovo;
}

export function orderHasGasDoPovoItems(items: Items[] | undefined): boolean {
  if (!items?.length) {
    return false;
  }
  return items.some(isGasDoPovoOrderItem);
}

export function isGasDoPovoProductInCatalog(
  productId: string | undefined,
  catalogProducts: CatalogProductsProps[] | null | undefined,
): boolean {
  if (!productId || !catalogProducts?.length) {
    return false;
  }
  const product = catalogProducts.find((item) => item.id === productId);
  return isGasDoPovoCatalogProduct(product);
}
